import axios from "axios";
import api from "@/api/api";

export const state = {
	effortProjectDetail: [],
	effortEmployeeProjectDetail: {},
	effortEmployeeProject: [],
	project: {},
  employees: [],
  positions: [],
  employeeEffort: {},
  projectsHistory: [],
};

// getters
export const getters = {
	effortProjectDetail: state => state.effortProjectDetail,
	effortEmployeeProjectDetail: state => state.effortEmployeeProjectDetail,
	effortEmployeeProject: state => state.effortEmployeeProject,
	project: state => state.project,
  employees: state => state.employees,
  positions: state => state.positions,
  employeeEffort: state => state.employeeEffort,
  projectsHistory: state => state.projectsHistory,
};

// mutations
export const mutations = {
	GET_EFFORT(state, payload) {
    payload.map(item => {
      if (item.effort === null) {
        if (item.effort_default !== null) {
          item.effort = item.effort_default;
        } else {
          item.effort = 100;
        }
      }
      if (item.set_value === null) {
        item.set_value = 1;
      }
    })
    state.effortProjectDetail = payload;
  },
  SET_EFFORT_EMPLOYEE_PROJECT(state, payload) {
    state.effortEmployeeProject = payload;
  },
  SET_EFFORT_EMPLOYEE_PROJECT_DETAIL(state, payload) {
    if (payload) {
      state.effortEmployeeProjectDetail = payload;
    }
  },
  PUSH_TO_EFFORT_EMPLOYEE_PROJECT_DETAIL(state, payload) {
    if (payload) {
      state.effortEmployeeProjectDetail = { ...state.effortEmployeeProjectDetail, ...payload }
    }
  },
  SET_EMPLOYEES(state, payload) {
    state.employees = payload;
  },
  SET_POSITIONS(state, payload) {
    state.positions = payload;
  },
  SET_EMPLOYEE_EFFORT(state, payload) {
    if (payload) {
      state.employeeEffort = payload;
    } else {
      state.employeeEffort = {};
    }
  },
  SET_PROJECTS_HISTORY(state, payload) {
    state.projectsHistory = payload;
  }
};

// actions
export const actions = {
	async getEffort({ commit }, payload) {
    const { id, date } = payload;
    const response = await axios.get(api.PROJECT_MANAGEMENT.EFFORT + '/' + id + '/effort',
      { params: { date } });
    commit('GET_EFFORT', response.data);
  },
  async postEffort(_, payload) {
    const { id, formData } = payload;
    const response = await axios.post(api.PROJECT_MANAGEMENT.EFFORT + '/' + id + '/effort', formData);
    return response;
    // commit('GET_EFFORT', response.data);
  },
  async getEffortEmployeeProject({ commit }, id) {
    const response = await axios.get(api.PROJECT_MANAGEMENT.EFFORT_EMPLOYEE_PROJECT.replace(":id", id));
    commit("SET_EFFORT_EMPLOYEE_PROJECT", response.data);
  },
  async getEffortEmployeeProjectDetail({ commit }, payload) {
    const response = await axios.get(api.PROJECT_MANAGEMENT.EFFORT_EMPLOYEE_PROJECT_DETAIL.replace(":id", payload.id) + `?start_date=${payload.startDate}&end_date=${payload.endDate}`);
    if (payload.isPushData) {
      commit("PUSH_TO_EFFORT_EMPLOYEE_PROJECT_DETAIL", response.data);
    } else {
      commit("SET_EFFORT_EMPLOYEE_PROJECT_DETAIL", response.data);
    }
  },
  async getEmployeeList({ commit }) {
    const response = await axios.get(api.LIST_EMPLOYEE_TO_SELECT);
    commit("SET_EMPLOYEES", response.data);
  },
  async getPositionList({ commit }) {
    const response = await axios.get(api.LIST_POSITION);
    commit("SET_POSITIONS", response.data);
  },
  async updateEmployeeList({ commit }, data) {
    commit("SET_EMPLOYEES", data);
  },
  async updateProjectEmployee(_, { data, id }) {
    let url = api.PROJECT_MANAGEMENT.UPDATE_PROJECT_EMPLOYEE.replace(":id", id);
    const response = await axios.post(url, data);
    return response;
  },
  async getEmployeeEffort({ commit }, { data, id }) {
    let url = api.PROJECT_MANAGEMENT.GET_EMPLOYEE_EFFORT.replace(":id", id) + `?start_date=${data.startDate}&end_date=${data.endDate}`;
    const response =  await axios.get(url, data);
    commit("SET_EMPLOYEE_EFFORT", response.data);
  },
  async getProjectsHistory({commit}, {id}) {
    const response = await axios.get(api.PROJECT_MANAGEMENT.GET_EMPLOYEE_PROJECT_HISTORY.replace(":id", id));
    commit("SET_PROJECTS_HISTORY", response.data);
  }
};
